import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver,ElementRef, EventEmitter, HostListener, SecurityContext, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import moment from 'moment';
import { ConsultationService } from 'src/app/services/consultation/consultation.service';
import { OrdonnancesService } from 'src/app/services/consultation/ordonnances/ordonnances.service';
import { CourrierContent } from 'src/app/services/display-document/display-document.service';
import { DocumentService } from 'src/app/services/document/document.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { PatientService } from 'src/app/services/patient/patient.service';
import { DocumentMetadata } from 'src/app/utils/interfaces/new/DocumentMetadata';
import { ImpressionOrdoHisto } from 'src/app/utils/interfaces/new/ImpressionOrdoHisto.interface';
import { QuillObjectDisplay } from 'src/app/utils/interfaces/new/quill-object-display.interface';
import { PieceJointe, QuickSendMSSFragment } from '../modal/quick-send-mss/quick-send-mss.fragment';
import { CourrierContentViewerComponent } from './courrier-content-viewer/courrier-content-viewer.component';
import { GEDImageViewerComponent } from './gedimage-viewer/gedimage-viewer.component';
import { GEDPdfViewerComponent } from './gedpdf-viewer/gedpdf-viewer.component';
import { DisplayContentData, GEDViewerComponent } from './gedviewer/gedviewer.component';
import { FroalaContentViewerComponent } from './froala-content-viewer/froala-content-viewer.component';
import { Ordonnance } from 'src/app/utils/interfaces/new/ordonnance';
import { EnvoiEprescription, InfoEprescription, InfoPatientEprescription } from '../modal/envoi-eprescription/envoi-eprescription.fragment';
import jsPDF from 'jspdf';
import { DmpService } from 'src/app/services/dmp/dmp.service';
import { LoginService } from 'src/app/services/login/login.service';
import { CreationPrescription } from 'src/app/services/ordonnance-numerique/connecteur-models';
import { OrdonnanceNumeriqueService, TraceEprescriptionType, TypeEprescriptionEnum } from 'src/app/services/ordonnance-numerique/ordonnance-numerique.service';
import { ResultEnum } from 'src/app/services/log-fonctionnel/log-fonctionnel.service';
import { environment } from 'src/environments/environment';
import { take } from 'rxjs/operators';
import { OrdonnanceLibre } from 'src/app/utils/interfaces/new/ordonnance-libre';
import { QuillUtilsService } from 'src/app/services/quill-utils/quill-utils.service';
import { Annexe } from '../modal/edit-courrier/edit-courrier.fragment';
import { PDFDocument } from 'pdf-lib';
import { SnackbarService } from 'src/app/services/snackbar/snackbar.service';
import { SafeHtmlUtils } from 'src/app/utils/safe-html.util';

export const HANDLED_IMAGE_MIME_TYPES = ['image/gif', 'image/png', 'image/jpeg', 'image/jpg', 'image/bmp', 'image/webp', 'image/svg+xml'];
export const HANDLED_PDF_MIM_TYPES = ['application/pdf'];
export const HANDLED_FROALA_CONTENT = ['froala-content'];
export const HANDLED_COURRIER = ['courrier-consultation', 'ordonnance-consultation', 'ordonnance-histo'];
export const HANDLED_HTML_CONTENT = ['text/html'];

export enum AskNextDocument {
  Next = 'next',
  Previous = 'previous'
}
@Component({
  selector: 'app-display-document',
  templateUrl: './display-document.component.html',
  styleUrls: [
    './display-document.component.scss',
    '../modal/modal.fragment.scss'
  ]
})
export class DisplayDocumentComponent implements AfterViewInit {

  @ViewChild('viewerContainer', { read: ViewContainerRef }) viewerContainer: ViewContainerRef;

  @ViewChild('modalBody') private modalBody: ElementRef;
  @ViewChild('outsideModal') private outsideModal: ElementRef;

  public closeEmitter = new EventEmitter<any>();
  public next = new EventEmitter<AskNextDocument>();
  public isNextDocument = true;
  public isPreviousDocument = true;
  public AskNextDocument = AskNextDocument;
  public isMail: boolean = false;
  public typeDocument: string | null = null;

  public document: DisplayContentData;
  public parentViewContainerRef: ViewContainerRef;
  public componentType: Type<any>;
  private gedViewer: GEDViewerComponent;
  public loading = true;
  public patientId: string;

  public idTexteModele: string; // id du texte modèle à partir duquel le courrier a été créé
  consultationId: string;
  selectBodyTable = {
      objects: []
    };
  ordonnance: Ordonnance;
  ordonnanceLibre: OrdonnanceLibre;
  retryEprescription: boolean;
  ePduplicationNumber: string;
  currentDmpReturn: any;
  printDirectly: boolean;
  private _printOverlay: HTMLDivElement | null = null;

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }

    if (!this.modalBody?.nativeElement?.contains(event.target) && this.outsideModal?.nativeElement?.contains(event.target)) {
      this.closeModal();
    }
  }

  constructor(
    private _componentFactoryResolver: ComponentFactoryResolver,
    private _cd: ChangeDetectorRef,
    private _documentSrv: DocumentService,
    private _odonnance: OrdonnancesService,
    private _domSanitize: DomSanitizer,
    private _modalService: ModalService,
    private _consultationService: ConsultationService,
    private _patientService: PatientService,
    private _dmpSrv: DmpService,
    private _loginService: LoginService,
    private _view: ViewContainerRef,
    private _ep: OrdonnanceNumeriqueService,
    private _snackbarService: SnackbarService
  ) { }

  ngAfterViewInit(): void {
    this._initComponent();
    if (this.isMail) {
      this.sendDocument();
    }
  }

  public downloadDocument(): void {
    this.gedViewer.download(this.document);
  }

  public async printDocument(): Promise<void> {
    if(this.ordonnance?.isEprescription && this.ordonnance.ePrescription) {
      const modaleConfirmDMP = this._modalService.openModalConfirmation(this._view, 'DMP', 'Voulez-vous envoyer cette ordonnance sur le DMP du Patient ?');
      const confirmationDMP = await new Promise<boolean>((resolve) => {
        const sub = modaleConfirmDMP.instance.closeEmitter.subscribe(async (res) => {
          resolve(res);
          sub.unsubscribe();
          modaleConfirmDMP.destroy();
        });
      });
      if (confirmationDMP) {
        await this.envoyerDMP();
      }
    } else if (!this.document?.retenueEnvoiDmp){
const modaleConfirmDMP = this._modalService.openModalConfirmation(this._view, 'DMP', 'Voulez-vous envoyer cette ordonnance sur le DMP du Patient ?');
      const confirmationDMP = await new Promise<boolean>((resolve) => {
        const sub = modaleConfirmDMP.instance.closeEmitter.subscribe(async (res) => {
          resolve(res);
          sub.unsubscribe();
          modaleConfirmDMP.destroy();
        });
      });
      if (confirmationDMP) {
        await this.envoyerDMP();
      }
      this.closeModal();
    } else if (this.document.fileName === "Ordonnance vierge"){
      this.closeModal();
    } else {
      this._ep.logTrace('transmettre', TraceEprescriptionType.PRESCRIPTION_HORS_EPRESCRIPTION, "", TypeEprescriptionEnum.PRODUITS_SANTE, ResultEnum.Success, "HORS EP", this.patientId, "", "")
      this.closeModal();
    }
    if (this.document.annexes && this.document.annexes.length > 0) {
      this.printWithAnnexes();
    } else {
      this.gedViewer.print(this.document);
    }

    if (this.document.contentType === HANDLED_COURRIER[1] && this.patientId && this.document.fileName != "Ordonnance vierge") {
      const printHisto: ImpressionOrdoHisto = {
        idConsultation: this.document.id,
        htmlText: '' + btoa(unescape(encodeURIComponent(this._domSanitize.sanitize(SecurityContext.HTML, this.document.data)))),
        idPatient: this.patientId,
        idOrdonnance: this.ordonnance ? this.ordonnance.id : undefined,
        idOrdonnanceLibre: this.ordonnanceLibre ? this.ordonnanceLibre.id : undefined,
      };
      const idHisto = await this._odonnance.histoPrintOrdonnance(printHisto);
      if(this.currentDmpReturn && this.currentDmpReturn.s_uniqueId) {
        this._dmpSrv.updateMyDocumentsDocumentId(this.currentDmpReturn.s_uniqueId, idHisto);
      }
    }
  }

  private async printWithAnnexes() {
    const loading = this._modalService.openLoading(this._view);
    try {
      // Création du PDF vide qui contiendra tout
      const pdfDoc = await PDFDocument.create();

      let doc: Document = this._getIframeDocument();
      if (!doc) throw new Error("Impossible de trouver le document HTML du courrier dans l'iframe");

      const base64Courrier = await this.generateBase64(doc.documentElement);

      // Import du courrier dans le PDF Master
      // On enlève le préfixe "data:application/pdf;filename=generated.pdf;base64,",
      const courrierBase64 = base64Courrier.split(',')[1];
      const binaryCourrier = atob(courrierBase64);
      const courrierBytes = new Uint8Array(binaryCourrier.length);
      for (let i = 0; i < binaryCourrier.length; i++) {
        courrierBytes[i] = binaryCourrier.charCodeAt(i);
      }
      const courrierPdf = await PDFDocument.load(courrierBytes, {
        ignoreEncryption: true,
        updateMetadata: false
      });
      const copiedPages = await pdfDoc.copyPages(courrierPdf, courrierPdf.getPageIndices());
      copiedPages.forEach((page) => pdfDoc.addPage(page));

      // Ajout des annexes
      for (const annexe of this.document.annexes) {
        try {
          // Décodage base64 de l'annexe
          const binaryString = atob(annexe.base64Data);
          const annexeBytes = new Uint8Array(binaryString.length);
          for (let i = 0; i < binaryString.length; i++) {
            annexeBytes[i] = binaryString.charCodeAt(i);
          }

          if (annexe.contentType === 'application/pdf') {
            // C'est un PDF : on copie ses pages
            // Ignorer le chiffrement et tenter de réparer les PDFs mal formés
            const annexePdf = await PDFDocument.load(annexeBytes, {
              ignoreEncryption: true,
              updateMetadata: false
            });
            const annexePages = await pdfDoc.copyPages(annexePdf, annexePdf.getPageIndices());
            annexePages.forEach((page) => pdfDoc.addPage(page));

          } else if (annexe.contentType.startsWith('image/')) {
            // C'est une image : on l'ajoute sur une nouvelle page
            let image;
            if (annexe.contentType === 'image/png') {
              image = await pdfDoc.embedPng(annexeBytes);
            } else {
              // JPEG (voir si les utilisateurs mettent d'autres formats d'image?)
              image = await pdfDoc.embedJpg(annexeBytes);
            }

            const page = pdfDoc.addPage();

            const { width, height } = image.scaleToFit(page.getWidth() - 40, page.getHeight() - 40);
            page.drawImage(image, {
              x: (page.getWidth() - width) / 2,
              y: (page.getHeight() - height) / 2,
              width,
              height,
            });
          }
        } catch (error) {
          let userMessage = '';

          if (error.message?.includes('encrypted') || error.message?.includes('Encrypted')) {
            userMessage = `Le PDF "${annexe.fileName}" est protégé et ne peut pas être ajouté au document. Veuillez l'imprimer séparément.`;
          } else if (error.message?.includes('PDFDict') || error.message?.includes('invalid')) {
            userMessage = `Le PDF "${annexe.fileName}" est corrompu ou mal formé et ne peut pas être ajouté. Veuillez l'imprimer séparément.`;
          } else {
            userMessage = `Impossible d'ajouter "${annexe.fileName}" au document. Veuillez l'imprimer séparément.`;
          }

          console.error(`Erreur lors de l'ajout de l'annexe ${annexe.fileName}:`, error);
          this._snackbarService.openSnackBarError(userMessage);
          // On continue pour les autres annexes même si une échoue
        }
      }

      // Sauvegarde et ouverture du PDF final
      const pdfBytes = await pdfDoc.save();
      const blob = new Blob([pdfBytes as any], { type: 'application/pdf' });
      const blobUrl = URL.createObjectURL(blob);

      // Ouverture dans une fenêtre d'impression (iframe invisible)
      const printIframe = document.createElement('iframe');
      printIframe.style.position = 'fixed';
      printIframe.style.right = '0';
      printIframe.style.bottom = '0';
      printIframe.style.width = '0';
      printIframe.style.height = '0';
      printIframe.style.border = 'none';
      document.body.appendChild(printIframe);

      printIframe.src = blobUrl;

      printIframe.onload = () => {
        this.showPrintOverlay();
        setTimeout(() => {
          printIframe.contentWindow?.print();
          this.hidePrintOverlay();
        }, 500);
      };

    } catch (e) {
      console.error('Erreur lors de la fusion des documents', e);
      this._snackbarService.openSnackBar('Erreur lors de la fusion des pièces jointes, impression du courrier seul');
      this.gedViewer.print(this.document);
    } finally {
      loading.destroy();
    }
  }


  private showPrintOverlay(): void {
    this.hidePrintOverlay();
    const overlay = document.createElement('div');
    overlay.style.cssText = [
      'position:fixed',
      'inset:0',
      'z-index:99999',
      'backdrop-filter:blur(4px)',
      '-webkit-backdrop-filter:blur(4px)',
      'background:rgba(0,0,0,0.25)',
      'pointer-events:all',
      'cursor:wait',
    ].join(';');
    document.body.appendChild(overlay);
    this._printOverlay = overlay;
  }

  private hidePrintOverlay(): void {
    if (this._printOverlay) {
      this._printOverlay.remove();
      this._printOverlay = null;
    }
  }

  public closeModal(): void {
    this.closeEmitter.emit();
  }

  public askNextDocument(nextDocument: AskNextDocument): void {
    this.next.emit(nextDocument);
  }

  public getTitle(): string {
    /**
     * TODO À revoir
     * Quick fix
     * Ce fonctionnement n'est pas optimal
     * Il faudrait que le template récupère directement une variable dont la valeur est le nom concaténé
     * Mais une erreur 'ExpressionChangedAfterItHasBeenCheckedError' est levée dans ce cas
     */

    return `${this.document.title} (${moment(this.document.date).format('DD/MM/YYYY')})`;
  }

  public canPrintDocument(): boolean {
    if (HANDLED_IMAGE_MIME_TYPES.includes(this.document.contentType)) {
      return true;
    } else if (HANDLED_FROALA_CONTENT.includes(this.document.contentType)) {
      return true;
    } else if (HANDLED_COURRIER.includes(this.document.contentType)) {
      return true;
    } else {
      return false;
    }
  }

  public canDownloadDocument(): boolean {
    if (HANDLED_IMAGE_MIME_TYPES.includes(this.document.contentType)) {
      return true;
    } else {
      return false;
    }
  }

  public canSendDocument(): boolean {
    return this.patientId && (this.document.contentType === HANDLED_COURRIER[0] || this.document.contentType === HANDLED_PDF_MIM_TYPES[0]);
  }


  private async sendDocument(): Promise<void> {
    if (!this.parentViewContainerRef) {
      return;
    }

    let pj: PieceJointe | undefined;
    if (this.document.contentType === HANDLED_PDF_MIM_TYPES[0]) {
      pj = {
        contentType: 'application/pdf',
        fileName: this.document.title,
        file: this.document.data,
        size: this.document.size,
        clinicalDocument: false,
        documentAssocieId: this.document.id,
        typeDocumentAssocie: 'pdf',
      };
    } else if (this.document.contentType === 'courrier-consultation') {
      let consultation;
      if (this.consultationId) {
        consultation = await this._consultationService.findOne(this.consultationId);
      }
      const infosPatient = await this._patientService.findOnePatientInfos(this.patientId);
      let data = this.document.data;
      if (typeof data !== 'string') {
        data = (data as any).changingThisBreaksApplicationSecurity;
      }
      pj = {
        contentType: 'courrier-consultation',
        fileName: "Courrier_Consultation" +
          (consultation ? "_" + moment(consultation.date).format('DD-MM-YYYY') : "") +
          (infosPatient ? "_" + infosPatient.nom + "_" + infosPatient.prenom : ""),
        file: data || '',
        size: this.document.size,
        clinicalDocument: false,
        documentAssocieId: this.document.id,
        typeDocumentAssocie: 'courrier',
      };
    }

    const quickSendMSS = this._modalService.openModal(this.parentViewContainerRef, QuickSendMSSFragment,
      [
        { name: 'idPatient', value: this.patientId },
        { name: 'title', value: this.document.title },
        { name: 'content', value: this.document.quilllessData },
        { name: 'pieceJointe', value: pj },
        { name: 'documentId', value: this.document.id },
        { name: 'correspondants', value: this.selectBodyTable.objects },
        { name: 'idTexteModele', value: this.idTexteModele },
        { name : 'typeDocument', value : this.typeDocument},
        { name : 'annexes', value : this.document.annexes},
      ]
    );

    const sub = quickSendMSS.instance.closeEmitter.subscribe((result) => {
      this.closeEmitter.emit({ type: 'quickSendDone', data: result });
      sub.unsubscribe();
      quickSendMSS.destroy();
    });
  }


  public async showNextDocument(document: DisplayContentData): Promise<void> {
    if (this.viewerContainer) {
      this.viewerContainer.clear();
    }
    this.document = document;

    if (HANDLED_IMAGE_MIME_TYPES.includes(document.contentType)) {
      this.componentType = GEDImageViewerComponent;
    } else if (HANDLED_PDF_MIM_TYPES.includes(document.contentType)) {
      this.componentType = GEDPdfViewerComponent;
    } else if (HANDLED_FROALA_CONTENT.includes(document.contentType)) {
      this.componentType = FroalaContentViewerComponent;
    } else if (HANDLED_COURRIER.includes(document.contentType)) {
      this.componentType = CourrierContentViewerComponent;
    } else if (HANDLED_HTML_CONTENT.includes(document.contentType)) {
      this.componentType = CourrierContentViewerComponent;
    }
    this.loading = true;
    try {
      const componentFactory = this._componentFactoryResolver.resolveComponentFactory(this.componentType);
      const gedViewer = this.viewerContainer.createComponent<GEDViewerComponent>(componentFactory);
      this.gedViewer = gedViewer.instance;

      if (!document.data) {
        const doc = await this._documentSrv.downloadDocument(document.id);
        document.data = DocumentService.prefixBase64(doc.payload, doc.contentType);
      }
      await gedViewer.instance.setData(document);
  if (gedViewer.instance instanceof CourrierContentViewerComponent && document.contentType === "ordonnance-consultation" && this.printDirectly) {
    const courrierViewer = gedViewer.instance as CourrierContentViewerComponent;

    courrierViewer.displayedDocument
    .pipe(take(1)) //evite d'unsubscribe car ne prend qu'une valeur et unsubscribe automatiquement
    .subscribe(() => this.onDocumentDisplayed());
    }
    } catch (e) {
      console.error(e);
    } finally {
      this.loading = false;
    }


    /**
     * TODO
     * Ici il faudrait obtenir le titre de la modal en concaténant comme ceci :
     * `${this.document.titre} (${moment(this.document.updatedAt ?
     *  this.document.updatedAt : this.document.createdAt).format('DD/MM/YYYY')})`
     *
     * Et alimenter une variable avec cette concaténation, puis laisser le template accéder à cette variable
     */

    this._cd.detectChanges();
  }

  onDocumentDisplayed(): void {
  //setTimeout necessaire car même si le document est rendu dans le DOM, le navigateur semble avoir besoin de temps pour l'afficher
  setTimeout(()=>{ this.printDocument(); },1000)
}

  public canDisplayDocument(contentType: string): boolean {
    return HANDLED_IMAGE_MIME_TYPES.includes(contentType)
      || HANDLED_PDF_MIM_TYPES.includes(contentType)
      || HANDLED_FROALA_CONTENT.includes(contentType);
  }

  private async _initComponent(): Promise<void> {
    await this.showNextDocument(this.document);
  }

  public documentToDisplayContentData(document: DocumentMetadata, patientId?: string): DisplayContentData {
    this.patientId = patientId;

    return {
      data: undefined,
      size: document.weight,
      date: document.updatedAt ? document.updatedAt : document.createdAt,
      fileName: document.fileName,
      id: document.id,
      title: document.titre,
      contentType: document.contentType,
      dataPrint: ''
    };
  }

  public QuillToDisplayContentData(quillObject: QuillObjectDisplay): DisplayContentData {
    let customPrintStyle = `
      body {
          font-family: Arial, Helvetica, sans-serif;
          margin: 0;
          height: auto;
          display: block;
      }
      table, th, td {
        border: 1px solid grey;
        border-collapse: collapse;
      }

      .ql-editor {
          padding:0 !important;
      }

      h6,
      h5,
      h4 {
        margin: 0 !important;
      }
      h5, h4{
        font-weight: 400 !important;
      }
      p {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
      }
      .ql-align-center{
        text-align: center !important;
      }
      .ql-align-right{
        text-align: right !important;
      }
      .ql-align-left{
        text-align: left !important;
      }
      .before-print-content{
        margin-bottom:15px !important;
      }
      p, li {
          font-size: 13px !important;
        }
        h4, ul{
          font-size: 16px !important;
        }
        h6 {
          font-weight: normal !important;
        }
        h3 {
          font-size: 18px !important;
        }
        h2 {
          font-size: 20px !important;
        }
        h1 {
          font-size: 24px !important;
        }

      @page {
          size: A4;
          margin-left:10mm;
          margin-right:10mm;
          margin-top:10mm;
          margin-bottom:10mm;
      }`

    let html = `
      <html>
        <head>
          <style>
          ${QuillUtilsService.setQuillPreviewStyle(customPrintStyle)}
          </style>
           <link href="https://cdnjs.cloudflare.com/ajax/libs/froala-editor/2.8.4/css/froala_editor.pkgd.min.css" rel="stylesheet" type="text/css" />
          <link href="https://cdnjs.cloudflare.com/ajax/libs/froala-editor/2.8.4/css/froala_style.min.css" rel="stylesheet" type="text/css" />
          <link href='https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.bubble.css' rel='stylesheet'>
          <link href='https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.core.css' rel='stylesheet'>
          <link href="https://cdnjs.cloudflare.com/ajax/libs/quill/1.3.7/quill.snow.css" rel="stylesheet">
          <script src="https://unpkg.com/pagedjs/dist/paged.polyfill.js"></script>
        </head>
        <body class="fr-view">
        ${SafeHtmlUtils.sanitizeHtmlString(quillObject.texte)}
        </body>
        </html>
        `

    return {
      data: html,
      date: quillObject.date ? quillObject.date : new Date(),
      fileName: quillObject.titre,
      id: quillObject.objectId,
      title: quillObject.titre,
      contentType: HANDLED_FROALA_CONTENT[0],
      dataPrint: ''
    };
  }

  public courrierToDisplayContentData(courrier: any, content: CourrierContent, patientId?: string, consultationId?: string, annexes?: Annexe[]): DisplayContentData {
    const title = courrier.titre
      ? courrier.titre : courrier.consultation.titre
        ? `Courier pour consultation ${courrier.consultation.titre}` : 'Courrier';

    if ((courrier.isOrdo && !courrier.isDuplicata) || (!courrier.isOrdo)) {
      this.patientId = patientId;
      this.consultationId = consultationId;
    }

    if (courrier.idTexteModele) {
      this.idTexteModele = courrier.idTexteModele;
    }

    if(courrier.isOrdo && courrier.ordonnance) {
      if ((courrier.ordonnance as any).bcbVersion) {
        this.ordonnance = courrier.ordonnance;
        this.ordonnanceLibre = null;
      } else {
        this.ordonnanceLibre = courrier.ordonnance;
        this.ordonnance = null;
      }
    }

    this.retryEprescription = false;
    if(courrier.ePrescriptionInfo && !courrier.ePrescriptionInfo.isSentOk && !courrier.ePrescriptionInfo.duplicateNumero) {
      this.retryEprescription = true;
    } else if (courrier.ePrescriptionInfo && courrier.ePrescriptionInfo.duplicateNumero) {
      this.ePduplicationNumber = courrier.ePrescriptionInfo.duplicateNumero;
    }
    return {
      data: content.fullContent,
      quilllessData: content.quillLessContent,
      date: courrier.creationDate,
      fileName: title,
      id: courrier.id,
      title,
      contentType: courrier.isOrdo ? HANDLED_COURRIER[1] : (courrier.isOrdoHisto ? HANDLED_COURRIER[2] :  HANDLED_COURRIER[0]),
      dataPrint: content.printContent,
      isPagedJSActive: (courrier.ordonnance && courrier.ordonnance.isEprescription) || content.isPagedActive,
      size: courrier.weight || content.fullContent?.length || 0,
      annexes: annexes,
      retenueEnvoiDmp: courrier.retenueEnvoiDmp
    };
  }

  public async continueEprescription() {
    if (this.ordonnance && this.ordonnance.isEprescription) {
      const patient = await this._patientService.findOnePatientInfos(this.patientId);
      const infoPatient: InfoPatientEprescription = {
        nom: patient.nom,
        prenom: patient.prenom,
        dateNaissance: patient.dateNaissance,
        taille: patient.taille,
        poids: patient.poids,
      }
      const modalEnvoi = this._modalService.openModal(
        this.viewerContainer, EnvoiEprescription,
        [
          {name: 'ordo', value: this.ordonnance},
          {name: 'infoPatient', value: infoPatient}
        ],
      );
      const infoEprescription = await new Promise((resolve) => {
        const sub = modalEnvoi.instance.closeEmitter.subscribe((res: InfoEprescription) => {
          this.loading = true;
          sub.unsubscribe();
          resolve(res);
        })
      });
      this.closeEmitter.emit(infoEprescription);
    }
  }
  private async generateBase64(htmlElement: HTMLElement): Promise<string> {
    const docJSPDF = new jsPDF({
      orientation: 'p',
      format: 'a4',
      unit: 'px',
      hotfixes: ['px_scaling',
      ],
    });

    const pdfRootId = `pdf-${Math.random().toString(36).substring(7)}`;
    htmlElement.setAttribute('data-pdf-root', pdfRootId);

    try {
      await docJSPDF.html(htmlElement, {
        autoPaging: 'text',
        margin: [10, 0, 10, 0],
        width: 790,
        windowWidth: 790,
        html2canvas: {
          backgroundColor: 'white',
          svgRendering: true,
          letterRendering: true,
          scale: 0.98,
          onclone: (clonedDocument: Document) => {
            const root = clonedDocument.querySelector<HTMLElement>(
              `[data-pdf-root="${pdfRootId}"]`
            );

            if (!root) {
              return;
            }

            const style = clonedDocument.createElement('style');
            style.innerHTML = `
              [data-pdf-root="${pdfRootId}"] .content,
              [data-pdf-root="${pdfRootId}"] .fr-view,
              [data-pdf-root="${pdfRootId}"] .ql-editor {
                font-size: 13px !important;
                line-height: 1.3 !important;
              }
              [data-pdf-root="${pdfRootId}"] .content div,
              [data-pdf-root="${pdfRootId}"] .fr-view p,
              [data-pdf-root="${pdfRootId}"] .fr-view span,
              [data-pdf-root="${pdfRootId}"] .fr-view li,
              [data-pdf-root="${pdfRootId}"] .fr-view td,
              [data-pdf-root="${pdfRootId}"] .fr-view th,
              [data-pdf-root="${pdfRootId}"] .fr-view div,
              [data-pdf-root="${pdfRootId}"] .ql-editor p,
              [data-pdf-root="${pdfRootId}"] .ql-editor span,
              [data-pdf-root="${pdfRootId}"] .ql-editor li,
              [data-pdf-root="${pdfRootId}"] .ql-editor td,
              [data-pdf-root="${pdfRootId}"] .ql-editor th,
              [data-pdf-root="${pdfRootId}"] .ql-editor div {
                font-size: 13px !important;
                line-height: 1.3 !important;
              }
              [data-pdf-root="${pdfRootId}"] .fr-view h1,
              [data-pdf-root="${pdfRootId}"] .ql-editor h1 { font-size: 18px !important; }
              [data-pdf-root="${pdfRootId}"] .fr-view h2,
              [data-pdf-root="${pdfRootId}"] .ql-editor h2 { font-size: 16px !important; }
              [data-pdf-root="${pdfRootId}"] .fr-view h3,
              [data-pdf-root="${pdfRootId}"] .fr-view h4,
              [data-pdf-root="${pdfRootId}"] .fr-view h5,
              [data-pdf-root="${pdfRootId}"] .fr-view h6,
              [data-pdf-root="${pdfRootId}"] .ql-editor h3,
              [data-pdf-root="${pdfRootId}"] .ql-editor h4,
              [data-pdf-root="${pdfRootId}"] .ql-editor h5,
              [data-pdf-root="${pdfRootId}"] .ql-editor h6 { font-size: 14px !important; }
            `;
            root.prepend(style);
          },
        },
      });

      const b64 = docJSPDF.output('datauristring');
      return b64;
    } finally {
      htmlElement.removeAttribute('data-pdf-root');
    }
  }

  public async dupliquerEp() {
    const modaleConfirmDup = this._modalService.openModalConfirmation(this._view, 'Duplication', 'Attention !\n\nÊtes-vous sûr de vouloir dupliquer cette prescription ? \n\n Cela renverra les données de cette e-Prescription à l\'Assurance Maladie pour générer un nouveau QR Code.');
    const confirmationDup = await new Promise<boolean>((resolve) => {
      const sub = modaleConfirmDup.instance.closeEmitter.subscribe(async (res) => {
        resolve(res);
        sub.unsubscribe();
        modaleConfirmDup.destroy();
      });
    });
    if (confirmationDup) {
      const idConsultation = this.ordonnance?.idConsultation || this.ordonnanceLibre?.idConsultation;
      const consultation = await this._consultationService.findOne(idConsultation);
      const patient = await this._patientService.findOnePatientInfos(consultation.idPatient);
      const infoPatient: InfoPatientEprescription = {
        nom: patient.nom,
        prenom: patient.prenom,
        dateNaissance: patient.dateNaissance,
        taille: patient.taille,
        poids: patient.poids,
      }
      const data = (this.ordonnance.ePrescription.rawDataEprescription) as CreationPrescription;
      const modalEnvoi = this._modalService.openModal(
        this._view, EnvoiEprescription,
        [
          {name: 'creationDirect', value: data},
          {name: 'infoPatient', value: infoPatient}
        ],
      );
      const ePrescriptionInfo = await new Promise<InfoEprescription>((resolve) => {
        const sub = modalEnvoi.instance.closeEmitter.subscribe(async (res) => {
          resolve(res);
          sub.unsubscribe();
          modalEnvoi.destroy();
        });
      });
      // On a eu un retour de l'ePrescription on raffiche
      if (ePrescriptionInfo && ePrescriptionInfo.isSentOk) {
        // Mode duplication
        ePrescriptionInfo.duplicateNumero = this.ordonnance.ePrescription.numeroEprescription;

        // Pas de sauvegarde des informations en base
        this.closeEmitter.emit(ePrescriptionInfo);
      }
    }
  }

  private _getIframeDocument(): Document | undefined {
    let doc: Document;
    const iframeNames = ['quill-iframe-courrier', 'quill-iframe', 'quill-iframe-hidden', 'iframe-apercu'];

    for (const name of iframeNames) {
      const iframeElement = document.querySelector(`iframe[name="${name}"]`) as HTMLIFrameElement;
      if (iframeElement && (iframeElement.contentDocument || iframeElement.contentWindow)) {
        doc = iframeElement.contentDocument || iframeElement.contentWindow.document;
        break;
      }
    }

    if (!doc) {
      for (const name of iframeNames) {
        if (window.frames[name]) {
          doc = window.frames[name].document;
          break;
        }
      }
    }

    if (!doc) {
       const iframes = document.querySelectorAll('app-gedviewer iframe');
       for (let i = 0; i < iframes.length; i++) {
          const iframe = iframes[i] as HTMLIFrameElement;
          if (iframe.contentDocument || iframe.contentWindow) {
             doc = iframe.contentDocument || iframe.contentWindow.document;
             break;
          }
       }
    }
    return doc;
  }

  private async envoyerDMP() {
    let loading = this._modalService.openLoading(this._view);
    try {
      const iframeDoc = this._getIframeDocument();
      if (!iframeDoc) {
        throw new Error("Impossible de trouver le document HTML dans l'iframe");
      }
      const base64 = await this.generateBase64(iframeDoc.documentElement);
      if (!base64) {
        loading.destroy();
        const alert = this._modalService.openAlert(this._view, 'Erreur', 'Une erreur est survenue lors de la génération du document');
        await new Promise<void>((resolve) => {
          const sub = alert.instance.closeEmitter.subscribe(() => {
            resolve();
            sub.unsubscribe();
            alert.destroy();
          });
        });
        return;
      }
      this._dmpSrv.resourceId = this._loginService.getCurrentProfil().id;
      const numeroTypeDocumentActe = "57832-8";
      const dmpTypeDocumentActe = this._dmpSrv.dmpTypeDocument.find((typeDocument) => typeDocument.meta.s_code === numeroTypeDocumentActe);
      if (!dmpTypeDocumentActe) {
        loading.destroy();
        const alert = this._modalService.openAlert(this._view, 'Erreur', 'Le type de document acte médical n\'a pas été trouvé dans le DMP');
        await new Promise<void>((resolve) => {
          const sub = alert.instance.closeEmitter.subscribe(() => {
            resolve();
            sub.unsubscribe();
            alert.destroy();
          });
        });
        return;
      }
      this.currentDmpReturn = await this._dmpSrv.sendRawPDFDocument(this._view, base64, this.patientId, dmpTypeDocumentActe, this.document.title);
    } catch (e) {
      loading.destroy();
      const alert = this._modalService.openAlert(this._view, 'Erreur', 'Une erreur est survenue lors de l\'envoi du document au DMP', undefined, e?.message);
      await new Promise<void>((resolve) => {
        const sub = alert.instance.closeEmitter.subscribe(() => {
          resolve();
          sub.unsubscribe();
          alert.destroy();
        });
      });
    } finally {
      if (loading) {
        loading.destroy();
      }
    }
  }

  public formatFileSize(bytes: number): string {
    if (!bytes) return '';

    const sizes = ['octets', 'Ko', 'Mo', 'Go'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));

    if (i === 0) return `${bytes} ${sizes[i]}`;
    return `${(bytes / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
  }

  public HtmlToDisplayContentData( object: QuillObjectDisplay ): DisplayContentData {
    const content = SafeHtmlUtils.sanitizeHtmlString( object.texte || '' );
    const printStyle = `
      @page {
        size: A4;
        margin: 10mm;
      }

      html,
      body {
        height: auto;
        overflow: visible;
      }

      body {
        margin: 0;
        font-family: Arial, Helvetica, sans-serif;
        font-size: 13px;
      }

      table,
      th,
      td {
        border: 1px solid grey;
        border-collapse: collapse;
      }

      p,
      li {
        font-size: 13px !important;
      }

      h6 {
        font-size: 13px !important;
        font-weight: normal !important;
      }

      h5,
      h4 {
        font-size: 16px !important;
        font-weight: 400 !important;
      }

      h3 {
        font-size: 18px !important;
      }

      h2 {
        font-size: 20px !important;
      }

      h1 {
        font-size: 24px !important;
      }

      h1,
      h2,
      h3,
      h4,
      h5,
      h6,
      p {
        margin-top: 0;
        margin-bottom: 0;
      }

      .ql-align-center {
        text-align: center !important;
      }

      .ql-align-right {
        text-align: right !important;
      }

      .ql-align-left {
        text-align: left !important;
      }

      @media print {
        html,
        body {
          height: auto !important;
          overflow: visible !important;
        }
      }
    `;

    const html = `
      <!DOCTYPE html>
      <html>
        <head>
          <meta charset="utf-8">

          <style>
            ${printStyle}
          </style>
        </head>

        <body>
          ${content}
        </body>
      </html>
    `;

    return {
      data: html,
      date: object.date || new Date(),
      fileName: object.titre,
      id: object.objectId,
      title: object.titre,
      contentType: HANDLED_FROALA_CONTENT[0],
      dataPrint: ''
    };
  }

}
